import actions from '../../actionTypes';

export default areaId => {
  return {
    type: actions.GET_ZONES,
    areaId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/getZones.js